module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/bg_header-813cd9a4cc1e450be4fbe3d7f4493c6f.png";